module.exports = __webpack_public_path__ + "static/media/non-verified-user-icon.a392a4ff.svg";